import { Text, View } from '@react-pdf/renderer'

import { commonPdfTableStyles } from '@features/exports/utils/commonTableStyles'

import { AmountKey } from '../../../enums/amountKey'
import { HeaderCellStyles } from '../styles/HeaderCellStyles'
import { AmountLine } from './AmountLine'

type AmountFieldRow = {
  name: string
  symbol?: string | null
  turnoverAmount?: number
  vatAmount?: number
}

interface FieldsListProps {
  fields: AmountFieldRow[]
  amountKeys: AmountKey[]
  locale?: string
  currency?: string
}

export const FieldsList = ({ fields, amountKeys, locale, currency }: FieldsListProps) => {
  const { symbolCell, mainGroupCell, symbolCellText } = HeaderCellStyles
  const { cell, bodyText, row } = commonPdfTableStyles

  return fields.map(({ symbol, name, turnoverAmount, vatAmount }, fieldIndex) => {
    const hasSymbol = Boolean(symbol)

    return (
      <View key={`field-${fieldIndex}`} style={row} wrap={false}>
        {hasSymbol ? (
          <>
            <View style={symbolCell}>
              <Text style={[bodyText, symbolCellText]}>{symbol}</Text>
            </View>
            <View style={mainGroupCell}>
              <Text style={[bodyText, symbolCellText]}>{name}</Text>
            </View>
          </>
        ) : (
          <View style={cell}>
            <Text style={bodyText}>{name}</Text>
          </View>
        )}
        <AmountLine
          amountKeys={amountKeys}
          currency={currency}
          fieldIndex={fieldIndex}
          locale={locale}
          turnoverAmount={turnoverAmount}
          vatAmount={vatAmount}
        />
      </View>
    )
  })
}
